import {Injectable} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {LoginWrapperComponent} from '../../../auth/login-wrapper/login-wrapper.component';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthStatesEnum } from '@mlc/types';

@Injectable({
    providedIn: 'root'
})
export class AuthModalService {
    private loginModal$!: Promise<HTMLIonModalElement>;
    constructor(private modalCtrl: ModalController, private route: ActivatedRoute, private router: Router) {
    }


    openLogin(state?: AuthStatesEnum | null) {
        this.loginModal$ = this.modalCtrl.create({
            component: LoginWrapperComponent,
            canDismiss: state === AuthStatesEnum.BIOMETRIC_AUTH ? false : true,
            presentingElement: state === AuthStatesEnum.BIOMETRIC_AUTH ? undefined: document.querySelector('app-auth-wrapper') as HTMLElement,
        });
        return this.loginModal$.then(modal => {
            modal.onWillDismiss().then(() => {
              this.router.navigate([], {
                relativeTo: this.route,
                queryParams: {}
              })
            })
            modal.present();
        });
    }

    closeLogin(state?: AuthStatesEnum | null) {
        this.loginModal$.then(modal => {
            if (state === AuthStatesEnum.BIOMETRIC_AUTH) {
                modal.remove();
            } else {
                modal.dismiss();
            }
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {}
            })
        })
    }
}
